<template>
  <div
    class="new-main-footer-revamp__item__contact"
    itemprop="address"
    itemscope
    itemtype="http://schema.org/PostalAddress"
  >
    <div class="new-main-footer-revamp__item__contact__title">
      Hubungi kami
    </div>
    <div class="new-main-footer-revamp__item__contact__body">
      <div class="body-wrapper">
        <div class="body-wrapper__item">
          <div class="body-wrapper__item__icon">
            <img
              :src="IconLoc"
              :alt="`Icon Hubungi Kami Head Office Lion Parcel`"
              height="20"
              width="20"
            >
          </div>
          <div class="body-wrapper__item__body">
            <div>
              <div class="body-wrapper__item__body__title">
                Kantor pusat
              </div>
              <div
                class="body-wrapper__item__body__desc"
                style="white-space: pre-line;"
                itemprop="streetAddress"
              >
                Jl. Agave Raya No. 55, Kedoya Selatan, Jakarta Barat, 11520
              </div>
            </div>
          </div>
        </div>
        <div class="body-wrapper__item">
          <div class="body-wrapper__item__icon">
            <img
              :src="IconMail"
              :alt="`Icon Email Lion Parcel`"
              height="20"
              width="20"
            >
          </div>
          <div class="body-wrapper__item__body">
            <div>
              <div class="body-wrapper__item__body__title">
                Customer Service
              </div>
              <div
                class="body-wrapper__item__body__desc"
                style="white-space: pre-line;"
                itemprop="email"
              >
                Email: <a href="mailto:help@lionparcel.com">help@lionparcel.com</a>
                <br>
                Telepon: <a href="tel:+622180820072">+6221-8082-0072</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconLoc from "@/assets/footer_address.svg";
import IconMail from "@/assets/footer_mail.svg";

export default {
  name: "ContactUsFooter",
  data() {
    return {
      IconLoc,
      IconMail,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./style";

a {
  color: $color-indigo-dark;
}
</style>
